import { IDeletePesquisaSatisfacaoItemUseCase } from "../../../presentation/useCases/delete/delete_pesquisa_satisfacao_item_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * DeletePesquisaSatisfacaoItemUseCase
 */

export class DeletePesquisaSatisfacaoItemUseCase implements IDeletePesquisaSatisfacaoItemUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async deletePesquisaSatisfacaoItem(
    idItemPesquisaSatisfacao: number
  ): Promise<void> {
    await this.repository.deletePesquisaSatisfacaoItem(idItemPesquisaSatisfacao);
  }
}
